// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3urp6","title":"styles_title__19LI3"};